import { DresonRuleResolvedEvent } from "../../types/FilterTypes";
import { eventQBus } from "../../types/EventQBus";
import { replaceNode } from "./Utils";

export default class LoadNavCategorySlider {
  static async onLoadNavCategorySlider(event: DresonRuleResolvedEvent): Promise<void> {
    const navCategorySliderNode: HTMLElement | null = document.getElementById("reptile-nav-category-slider");

    if (!navCategorySliderNode) {
      return;
    }

    /*                                                 */
    const { rule } = navCategorySliderNode.dataset;
    if (!event.rule || rule === event.rule) {
      return;
    }

    await fetch(LoadNavCategorySlider.uri(event.rule))
      .then(LoadNavCategorySlider.extractResponseText)
      .then((html: string) => replaceNode(navCategorySliderNode, event.rule, html))
      .then(LoadNavCategorySlider.emitNavCategorySliderLoaded)
      .catch((e: Error) => {
        console.warn(`Filter reload AJAX GET against ${LoadNavCategorySlider.uri(event.rule)} failed: ${e.message}`);
      });
  }

  private static extractResponseText(xhr: Response) {
    if (xhr.status !== 200) {
      throw Error(`Failed to retrieve category slider: ${xhr.status} ${xhr.statusText}`);
    }
    return xhr.text();
  }

  private static emitNavCategorySliderLoaded() {
    eventQBus.emit("ftfind.categorySlider.loaded");
  }

  private static uri(dataRule: string): string {
    const ruleString = encodeURIComponent(dataRule);
    return `/nav-promirnaty/pl-category-slider/${ruleString}`;
  }
}
